import { AfterViewInit, Component, inject } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { Folder } from '../folder/folder.model';
import { FolderService } from '../folder/folder.service';
import { BaseComponent } from '../shared/base.component';
import { SiteHeaderComponent } from '../site-header/site-header.component';

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [
        SiteHeaderComponent
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.css'
})
export class HomeComponent extends BaseComponent implements AfterViewInit {

    private folderService: FolderService = inject(FolderService);

    private static _retrievingFirmwareFolders = "Retrieving Firmware Folders";
    private static _retrievingFirmwareFoldersError = `${HomeComponent._retrievingFirmwareFolders} error:`;

    ngAfterViewInit(): void {
        const userAccount = this.stateManager.getUserAccount();

        if (userAccount.user_roles.includes("manufacturing-info")) {
            this.getFirmwareFolders();
        }
    }

    protected async getFirmwareFolders() {
        // ToDo - The following getFirmwareFolders method is here to support dynamically
        //        building the nested firmware folder structure in the SiteHeadersComponent html.
        //        For now the nested firmware folder structure is hardcoded. Come back another
        //        time and change the html to work with the folders returned by this function.
        //        
        //        From an Angular lifecycle perspective, putting the folders array into a signal
        //        within the StateManager, and then referencing that signal from the functions of
        //        the BaseComponent (inherited by the SiteHeaderComponent) works fine.
        //
        //        The part that needs to be figured out is how to write the html within the
        //        SiteHeaderComponent to work with the nested folders array.
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            const observable = this.folderService.getFolders(await getIdToken(currentUser), "firmware")

            observable.subscribe(response => {
                try {
                    const json = JSON.parse(JSON.stringify(response));

                    if (json["get-firmware-folders"] == "success") {
                        super.firmwareFolders = Folder.toFolders(json["folders"]);
                    } else {
                        throw new Error(json["message"]);
                    }
                } catch (error) {
                    const message = `${HomeComponent._retrievingFirmwareFoldersError} ${(<Error>error).message}`;
                    console.error(message);
                    super.message = message;
                }
            });
        } else {
            const message = `${HomeComponent._retrievingFirmwareFoldersError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }
}
